import styled from 'styled-components'

const StyledDatePicker = styled.div`
  width: 100%;
  .react-datepicker-wrapper {
    width: 100%;
  }

  .react-datepicker {
    border: none;
    padding: ${({ theme }) => theme.space.S8} 0;
    font-family: ${({ theme }) => theme.fonts.textCondensedFont};
    box-shadow: rgba(77, 90, 106, 0.25) 0px 3px 30px, rgba(77, 90, 106, 0.25) 0px 0px 30px, rgba(0, 0, 0, 0.1) 0px 4px 30px;
  }

  .react-datepicker__header {
    background-color: ${({ theme }) => theme.colors.white};
    border-bottom: none;
    padding-top: ${({ theme }) => theme.space.S12};
  }

  .react-datepicker-popper {
    z-index: 10000;
  }

  .react-datepicker-popper[data-placement^='bottom'] {
    margin-top: 0;
  }

  .react-datepicker__day-name {
    color: ${({ theme }) => theme.colors.grey};
  }

  .react-datepicker__day,
  .react-datepicker__day-name {
    outline: 0;
  }

  .react-datepicker__month .react-datepicker__month-text {
    margin: 4px;
  }

  .react-datepicker__month-text {
    padding: 4px;
  }

  .react-datepicker__close-icon::after {
    content: '✖';
    background-color: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.grey};
    border: 1.5px solid ${({ theme }) => theme.colors.grey};
    padding: 0;
    box-sizing: border-box;
  }

  .react-datepicker__close-icon:hover::after {
    color: ${({ theme }) => theme.colors.greyLight};
    border: 1.5px solid ${({ theme }) => theme.colors.greyLight};
  }

  .react-datepicker__day--in-range {
    background-color: ${({ theme }) => theme.colors.bgVioletLight};
  }

  .react-datepicker__day--today,
  .react-datepicker__month-text--today {
    color: ${({ theme }) => theme.colors.violet};
  }

  .react-datepicker__day--keyboard-selected,
  .react-datepicker__month-text--keyboard-selected {
    color: ${({ theme }) => theme.colors.violet};
    background-color: ${({ theme }) => theme.colors.bgVioletLight};
  }

  .react-datepicker__day--selected,
  .react-datepicker__day--range-start,
  .react-datepicker__day--range-end,
  .react-datepicker__month--selected,
  .react-datepicker__month-text--selected {
    color: ${({ theme }) => theme.colors.white};
    background-color: ${({ theme }) => theme.colors.violet};
  }

  .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range, .react-datepicker__day--selecting-range-start) {
    background-color: ${({ theme }) => theme.colors.bgVioletLight};
  }

  .react-datepicker__day--selecting-range-start:not(.react-datepicker__day--in-range) {
    color: ${({ theme }) => theme.colors.white};
    background-color: ${({ theme }) => theme.colors.violet};
  }

  .react-datepicker__day:hover,
  .react-datepicker__month-text:hover {
    position: relative;
    background-color: transparent;
  }

  .react-datepicker__day--outside-month {
    color: ${({ theme }) => theme.colors.greyLight};
  }

  .react-datepicker__day--in-selecting-range:hover,
  .react-datepicker__day--in-range:hover {
    background-color: ${({ theme }) => theme.colors.bgVioletLight};
  }

  .react-datepicker__day--selected:hover,
  .react-datepicker__day--range-start:hover,
  .react-datepicker__day--range-end:hover,
  .react-datepicker__day--keyboard-selected:hover,
  .react-datepicker__month-text--keyboard-selected:hover,
  .react-datepicker__month-text--selected:hover {
    position: relative;
    background-color: ${({ theme }) => theme.colors.violet};
  }

  .react-datepicker__day--keyboard-selected:hover,
  .react-datepicker__month-text--keyboard-selected:hover {
    color: ${({ theme }) => theme.colors.white};
  }

  .react-datepicker__day--selected:hover,
  .react-datepicker__day--keyboard-selected:hover,
  .react-datepicker__day:hover,
  .react-datepicker__month-text:hover {
    &:after {
      content: '';
      border: 1px solid ${({ theme }) => theme.colors.violet};
      position: absolute;
      top: -2px;
      bottom: -2px;
      left: -2px;
      right: -2px;
      background: transparent;
    }
  }

  .react-datepicker__month-text.react-datepicker__month--selected:hover {
    background-color: ${({ theme }) => theme.colors.violet};
  }

  .react-datepicker__day--disabled {
    background: ${({ theme }) => theme.colors.bgLight};
    color: ${({ theme }) => theme.colors.grey};
    cursor: not-allowed;
    margin: 0;
    padding: 0.166rem;
    box-sizing: content-box;

    &:hover {
      background: ${({ theme }) => theme.colors.bgLight};

      &:after {
        border: none;
      }
    }
  }

  .react-datepicker__month-text--disabled {
    background: ${({ theme }) => theme.colors.bgLight};
    color: ${({ theme }) => theme.colors.grey};
    cursor: not-allowed;
    margin: 0;

    &:hover {
      background: ${({ theme }) => theme.colors.bgLight};

      &:after {
        border: none;
      }
    }
  }

  .react-datepicker__day--disabled.react-datepicker__day--selected {
    color: ${({ theme }) => theme.colors.white};
    background-color: ${({ theme }) => theme.colors.violet};

    &:hover {
      background-color: ${({ theme }) => theme.colors.violet};
    }
  }
`

export default StyledDatePicker
